<template>
  <Layout>
    <p v-if="this.falseLogin" class="login-error">
      <BaseIcon name="exclamation-circle" class="icon" size="lg" />
      Oops! No user found with the given credentials.
    </p>
    <form class="form" @submit.prevent="login">
      <md-field>
        <label>E-mail</label>
        <md-input v-model="email" type="mail" name="email" />
      </md-field>
      <md-field>
        <label>Password</label>
        <md-input v-model="password" type="password" name="password" />
      </md-field>
      <BaseButton color="primary" type="submit" size="big">Login</BaseButton>
    </form>
    <router-link class="center underline" to="/forgot-password">forgot password?</router-link>
  </Layout>
</template>

<script>
import Layout from "@/layouts/Authentication.vue";
import BaseIcon from "@/components/base/Icon";
import BaseButton from "@/components/base/Button.vue";

export default {
  name: "Login",
  components: { Layout, BaseButton, BaseIcon },
  data() {
    return {
      email: "",
      password: "",
      falseLogin: false
    };
  },
  mounted() {
    let currentToken = localStorage.getItem('token')
    if(currentToken != "" || currentToken != undefined || currentToken != null) {
      this.$router.push("/")
    }
  },
  methods: {
    login: function() {
      var that = this
      let email = this.email;
      let password = this.password;
      this.$store
        .dispatch("login", { email, password })
        .then(() => this.$router.push("/"))
        .catch(
          err => that.falseLogin = true
        );
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;

  &.forgotpass {
    padding: 30px 0;
    .row:last-child {
      margin-top: 10px;
    }
  }

  .inputGroup {
    display: flex;
    flex-direction: column;
    width: 100%;
    label {
      margin-bottom: 5px;
      font-size: 18px;
    }
    + a {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .btn {
    display: block;
    margin: 25px auto 0;
  }

  .authError {
    width: 100%;
    font-size: 14px;
    color: #ff0000;
    text-align: center;
  }

  .btn {
    display: block;
    width: 100%;
    margin: 25px 0;
  }
}

.login-error {  
  position: absolute;
  display: flex;
  border-radius: 8px;
  padding: 4px 8px;
  margin-top: -28px;
  background-color: #FBDACF;
  font-size: 14px;
  font-weight: 600;
  color: #E92900;

  .icon {
    color: #E92900;
    margin-right: 8px;
  }
}
</style>
